import { TypedDocumentNode, gql } from "@apollo/client";

export interface CategorizedCourseInterface {
  categoriesCourses: {
    id: string;
    name: string;
    totalCourse: number;
    slug: string;
    courses: ServiceByTypeInterface[];
  }[];
}

export enum CoursesCategoryType {
  IS_POPULAR = "IS_POPULAR",
  IS_CERTIFICATION_PROGRAM = "IS_CERTIFICATION_PROGRAM",
  IS_SKILL_BASED_COURSES = "IS_SKILL_BASED_COURSES",
  IS_NEW_LAUNCHED = "IS_NEW_LAUNCHED",
}

export const CATEGORIZED_COURSES_QUERY: TypedDocumentNode<
  CategorizedCourseInterface,
  CoursesCategoryType
> = gql`
  query GetCategorizedCourses($categoryType: CoursesCategoryType) {
    categoriesCourses(categoryType: $categoryType) {
      id
      name
      totalCourse
      slug
      courses {
        id
        name
        numberOfLearners
        isPopular
        slug
        serviceTrainingDays
        price
        currency
        service_image
        accreditation_name
        numberOfLearners
        serviceIcon
        mode_of_training
        serviceFlags
        isGenericPageOnly
      }
    }
  }
`;
